export const TURKISH_MESSAGES = {
  "bottomNav": {
    "client": {
      "home": "Ev",
      "cart": "Sepet",
      "tracking": "Takip",
      "profile": "Profil"
    },
    "vendor": {
      "dashboard": "Kontrol Paneli",
      "inventory": "Envanter",
      "orders": "Siparişler",
      "profile": "Profil"
    },
    "courier": {
      "dashboard": "Kontrol Paneli",
      "runs": "İşler",
      "route": "Rota",
      "profile": "Profil"
    },
    "admin": {
      "dashboard": "Kontrol Paneli",
      "manage": "Üstesinden gelmek",
      "notifications": "Uyarılar",
      "profile": "Profil"
    },
    "ambassador": {
      "dashboard": "Kontrol Paneli",
      "network": "Ağ",
      "accounts": "Eklemek",
      "profile": "Profil"
    }
  },
  "desktopShell": {
    "brand": "Riveltime",
    "tagline": "Operasyon kokpiti",
    "nav": {
      "ariaLabel": "Ana masaüstü navigasyonu",
      "title": "Navigasyon"
    },
    "platform": {
      "tablet": "Tablet",
      "desktop": "Masaüstü"
    },
    "role": {
      "label": "Rol",
      "client": "Müşteri",
      "vendor": "Satıcı",
      "courier": "Kurye",
      "admin": "Yönetici",
      "guest": "Misafir"
    },
    "connection": {
      "label": "Ağ"
    },
    "actions": {
      "home": "Eve dön"
    },
    "alt": {
      "logo": "Riveltime logosu"
    }
  },
  "common": {
    "delete": "Silmek"
  },
  "supportIssue": {
    "title": "Bir sorunu bildirin",
    "subtitle": "Hedef yanıt 24 iş saati içinde. Teknik detaylar isteğe bağlıdır.",
    "queuedTitle": "Sorun sıraya alındı",
    "sentTitle": "Sorun gönderildi",
    "queuedBody": "Bilet çevrimdışına kaydedildi. Ağ geri döndüğünde otomatik olarak senkronize edilecektir.",
    "sentBody": "Teşekkürler. Biletiniz desteğe gönderildi.",
    "dateLabel": "Tarih",
    "localId": "Yerel Kimlik",
    "ticketId": "Bilet Kimliği",
    "close": "Kapalı",
    "introTitle": "Konuyu kısaca açıklayın",
    "introBody": "Eylemi, ne beklediğinizi ve ne olduğunu açıklayın.",
    "category": "Kategori",
    "impact": "Darbe",
    "description": "Tanım",
    "descriptionPlaceholder": "Örnek: Vitrin üzerinden ödeme yapmayı denedim, ardından ödeme onaylanmadan sayfa takılı kaldı.",
    "descriptionCounter": "Minimum {{count}}/{{min}}",
    "technicalTitle": "Teknik ayrıntılar (isteğe bağlı)",
    "technicalContextLabel": "Teknik bağlamı ekleyin (rota, cihaz, uygulama sürümü, ağ).",
    "screenshotLabel": "Ekran görüntüsünü ekleyin (çok yakında, şu anda devre dışı).",
    "sensitiveWarning": "Asla hassas verileri (şifre, jeton, ödeme verileri) dahil etmeyin.",
    "previewTitle": "Ekli teknik ayrıntıların önizlemesi",
    "previewRole": "Rol",
    "previewLocation": "Konum",
    "previewDevice": "Cihaz",
    "previewEmail": "E-posta",
    "previewPhone": "Telefon",
    "previewDateTime": "Tarih / Saat",
    "na": "yok",
    "send": "Raporu gönder",
    "sending": "Gönderiliyor...",
    "retryIn": "{{seconds}}s içinde tekrar gönderebilirsiniz.",
    "sla": "Hedef yanıt süresi: 24 iş saati.",
    "locationLoading": "Yükleniyor...",
    "locationUnavailable": "Kullanılamıyor",
    "locationDenied": "İzin verilmiyor",
    "queueError": "Bilet sıraya alınamıyor.",
    "submitError": "Rapor gönderilemiyor.",
    "categories": {
      "account_auth": "Hesap / Giriş",
      "orders_delivery": "Siparişler / Teslimat",
      "payments_billing": "Ödemeler / Faturalandırma",
      "map_location": "Harita / Konum",
      "ui_bug": "kullanıcı arayüzü hatası",
      "performance": "Performans",
      "other": "Diğer"
    },
    "impacts": {
      "blocking": "Engelleme",
      "degraded": "Bozulmuş",
      "minor": "Küçük",
      "cosmetic": "Kozmetik"
    }
  },
  "verifyEmail": {
    "verifiedSessionRefreshing": "E-posta doğrulandı. Oturumunuz güncelleniyor...",
    "openMailboxToast": "E-posta gelen kutunuzu açın",
    "resendThrottled": "İstek {{email}} adresine gönderildi. Auth0 hız sınırları istekleri, e-posta gecikebilir.",
    "verificationLinkReady": "Doğrulama bağlantısı {{email}} için hazır. Adresinizi doğrulamak için açın.",
    "verificationResent": "Doğrulama e-postası {{email}} adresine yeniden gönderildi. Spam klasörünüzü kontrol edin.",
    "requestAcceptedNoConfirmation": "İstek kabul edildi ancak sunucu onayı döndürülmedi.",
    "tooManyRequests": "Yakın zamanda zaten bir e-posta talebinde bulundunuz. Birkaç dakika sonra tekrar deneyin.",
    "sendError": "Doğrulama e-postası gönderilirken hata oluştu.",
    "invalidEmail": "Geçerli bir e.",
    "emailUpdated": "E-posta güncellendi. Yeni bir doğrulama e-postası gönderildi.",
    "emailInUse": "E-posta zaten kullanıldı. Başka bir adres deneyin.",
    "emailUpdateError": "E-posta adresi güncellenemiyor.",
    "sessionInvalid": "Geçersiz oturum. Lütfen tekrar oturum açın.",
    "deleteFailed": "Hesap silinemedi. Lütfen daha sonra tekrar deneyin.",
    "alreadyVerified": "Adres zaten doğrulandı. Hesabınıza erişebilirsiniz.",
    "title": "E-postanızı doğrulayın",
    "subtitle": "Şuraya bir onay bağlantısı gönderdik:",
    "sentStep": "Gönderilmiş",
    "openLinkStep": "Bağlantıyı aç",
    "verifiedStep": "Doğrulandı",
    "resendNow": "E-postayı yeniden gönder",
    "resendIn": "{{seconds}}s içinde yeniden gönder",
    "openingMailbox": "Posta kutusunu aç",
    "editEmail": "E-posta adresini düzenle",
    "logout": "oturumu Kapat",
    "deleteProfile": "Profilimi sil",
    "goToSpace": "Benim alanıma git",
    "tipsSpam": "Ayrıca spam klasörünüzü de kontrol edin. Bağlantının süresi sınırlı bir süre sonra sona erer.",
    "tipsChangeEmail": "Yukarıda adresinizi değiştirebilirsiniz: yeni bir bağlantı gönderilecektir.",
    "helpTitle": "Yardıma mı ihtiyacınız var?",
    "help1": "Bağlantıyı aynı tarayıcıda açın.",
    "help2": "Doğrulama için özel taramadan kaçının.",
    "help3": "Bağlantının süresi dolmuşsa e-postayı yeniden gönderin.",
    "modalTitle": "E-posta adresini düzenle",
    "modalBody": "Güncellendikten sonra yeni bir doğrulama e-postası gönderilecektir.",
    "modalPlaceholder": "yeni-adres@email.com",
    "cancel": "İptal etmek",
    "confirm": "Onaylamak",
    "close": "Kapalı",
    "deleteConfirm": "Bu eylem geri döndürülemez. Not: Aktif siparişler varken silme işlemi engellenir.",
    "activeOrders_one": "Silinmesi imkansız: {{count}} emri hâlâ etkin",
    "activeOrders_other": "Silinmesi imkansız: {{count}} siparişler hâlâ etkin",
    "activeOrdersGeneric": "Silinmesi imkansız: aktif siparişler hala mevcut",
    "unknownEmail": "-",
    "sending": "Gönderiliyor..."
  },
  "legalViewer": {
    "notFoundTitle": "Belge bulunamadı",
    "notFoundDescription": "İstenilen belge mevcut değil. URL'yi kontrol edin.",
    "version": "Sürüm {{version}}",
    "fileMissing": "PDF dosyasına ulaşılamıyor. Public{{path}} içinde mevcut olduğunu doğrulayın.",
    "inlinePreviewUnsupported": "Satır içi önizleme bu cihazda tam olarak desteklenmiyor. Belgeyi açabilirsiniz:",
    "openPdf": "PDF'yi aç",
    "downloadPdf": "İndirmek",
    "pdfTitle": "PDF {{title}}",
    "previewError": "Önizleme kullanılamıyor. PDF'yi Aç düğmesini kullanın.",
    "openPdfNewTab": "PDF'yi yeni bir sekmede aç",
    "firstNameLabel": "İlk adı",
    "firstNamePlaceholder": "Adınızı girin",
    "lastNameLabel": "Soy isim",
    "lastNamePlaceholder": "Soyadınızı girin",
    "identityRequired": "Bu şartları kabul etmek için ad ve soyad gereklidir.",
    "acceptLabel": "{{title}} (sürüm {{version}}) okudum ve kabul ediyorum.",
    "acceptSaving": "Kaydediliyor...",
    "acceptCta": "Kabul ediyorum",
    "acceptError": "Kabul kaydedilemiyor. Lütfen kısa süre sonra tekrar deneyin."
  },
  "vitrine": {
    "productDetails": "Ürün ayrıntıları",
    "noDescription": "Açıklama sağlanmadı.",
    "basePrice": "Taban fiyat",
    "preparedFast": "Hızla hazırlandı",
    "currentPrice": "Güncel fiyat",
    "optionsIncluded": "Dahil edilen seçenekler (+{{amount}})",
    "required": "gerekli",
    "maxSelections": "Maksimum {{count}} seçim(ler)",
    "selectionsCount": "{{count}} seçim(ler)",
    "orderTotal": "Sipariş toplamı",
    "addToCart": "Sepete ekle",
    "loadingError": "Vitrin verileri yüklenirken hata oluştu.",
    "networkTitle": "Bağlantı kullanılamıyor",
    "networkDescription": "Ağınızı kontrol edin ve vitrini yeniden yükleyin.",
    "notFoundTitle": "Mağaza bulunamadı",
    "notFoundDescription": "Bu vitrin artık mevcut olmayabilir.",
    "unavailableTitle": "Hizmet geçici olarak kullanılamıyor",
    "unavailableDescription": "Hizmet şu anda yavaş. Birkaç saniye sonra tekrar deneyin.",
    "genericTitle": "Bu vitrin görüntülenemiyor",
    "genericDescription": "Yükleme sırasında bir hata oluştu. Şimdi tekrar deneyebilirsiniz.",
    "reloading": "Yeniden yükleniyor...",
    "retry": "Yeniden dene",
    "backHome": "Eve dön",
    "searchProduct": "Ürün ara",
    "searchPlaceholder": "Ürün ara...",
    "allCollections": "Tüm",
    "filtersTitle": "Ürün filtreleri",
    "collectionsTitle": "Koleksiyonlar",
    "viewModeTitle": "Görünüm modu",
    "viewModeGrid": "Izgara",
    "viewModeList": "Liste",
    "resetFilters": "Filtreleri sıfırla",
    "viewDetails": "Ayrıntıları görüntüle",
    "addedToCart": "{{name}} sepete eklendi",
    "seller": "Satıcı",
    "delay_day_one": "{{count}} gün",
    "delay_day_other": "{{count}} gün",
    "delay_hour_one": "{{count}}h",
    "delay_hour_other": "{{count}}h",
    "delay_minute_one": "{{count}} dk.",
    "delay_minute_other": "{{count}} dk.",
    "quantityTimesUnit": "{{qty}} x {{unitPrice}}"
  },
  "notificationBanner": {
    "close": "Kapalı",
    "updateAvailable": "Yeni sürüm mevcut. Uygulamayı güncellemek için tıklayın."
  },
  "header": {
    "sections": {
      "vendor": {
        "dashboard": "Kontrol Paneli",
        "inventory": "Envanter",
        "orders": "Siparişler",
        "profile": "Profil",
        "messages": "Mesajlar"
      },
      "courier": {
        "dashboard": "Kontrol Paneli",
        "runs": "Koşular",
        "route": "Rota",
        "profile": "Profil",
        "messages": "Mesajlar"
      },
      "ambassador": {
        "dashboard": "Kontrol Paneli",
        "network": "Ağ",
        "accounts": "Eklemek",
        "profile": "Profil"
      }
    },
    "labels": {
      "deliverTo": "Teslim et"
    },
    "connection": {
      "connected": "Bağlı",
      "reconnecting": "Yeniden bağlanılıyor...",
      "offline": "Çevrimdışı"
    },
    "gps": {
      "ok": "GPS tamam",
      "disabledActivate": "GPS devre dışı - Etkinleştir",
      "unavailableRetry": "GPS kullanılamıyor - Tekrar deneyin",
      "locating": "Bulunuyor...",
      "retryTitle": "Konumu yeniden dene",
      "activateTitle": "Konumu etkinleştir"
    },
    "boutiques": {
      "loading": "Mağazalar...",
      "count_one": "{{count}} mağaza",
      "count_other": "{{count}} mağaza"
    },
    "address": {
      "chooseTitle": "Bir teslimat adresi seçin",
      "choose": "Bir adres seçin",
      "currentSelected": "Geçerli seçili adres: {{label}}",
      "undetermined": "ayarlanmamış"
    },
    "syncBanner": {
      "pending_one": "Senkronizasyon bekleniyor ({{count}} eylemi).",
      "pending_other": "Senkronizasyon beklemede ({{count}} işlemler).",
      "syncing": "Senkronizasyon devam ediyor.",
      "retryNeeded_one": "Bir eylem senkronize edilemedi.",
      "retryNeeded_other": "{{count}} eylemleri senkronize edilemedi.",
      "blockedActions_one": "Bir eylemin dikkatinize ihtiyacı var.",
      "blockedActions_other": "{{count}} eylemleriyle ilgilenmeniz gerekiyor.",
      "viewDetails": "Ayrıntıları görüntüle",
      "retryNow": "Yeniden dene"
    }
  },
  "offlineQueue": {
    "title": "Senkronizasyon",
    "description": "Değişiklikleriniz kaydedildi. Otomatik olarak gönderilecektir.",
    "summary": {
      "title": "Mevcut durum",
      "upToDate": "Her şey güncel.",
      "sending": "Gönderim devam ediyor...",
      "pending_one": "{{count}} güncelleme gönderilmeyi bekliyor.",
      "pending_other": "{{count}} güncellemeler gönderilmeyi bekliyor.",
      "attention_one": "{{count}} güncellemesiyle ilgilenmeniz gerekiyor.",
      "attention_other": "{{count}} güncellemeleriyle ilgilenmeniz gerekiyor."
    },
    "badges": {
      "upToDate": "Güncel",
      "sending": "Gönderiliyor",
      "pending_one": "{{count}} bekliyor",
      "pending_other": "{{count}} bekliyor",
      "attention_one": "İncelenecek {{count}}",
      "attention_other": "İncelenecek {{count}}"
    },
    "status": {
      "pending": "Gönderilmeyi bekliyorum",
      "sending": "Gönderim devam ediyor",
      "attention": "İlginize ihtiyacı var"
    },
    "createdAt": "{{date}} tarihinde kaydedildi",
    "empty": "Hiçbir güncelleme beklenmiyor.",
    "error": {
      "generic": "Bu güncelleme şu anda gönderilemiyor."
    },
    "cta": {
      "sending": "Gönderiliyor...",
      "retryNow": "Şimdi yeniden dene",
      "retry": "Yeniden dene",
      "removeUpdate": "Bu güncellemeyi kaldır",
      "removeFromList": "Listeden kaldır"
    },
    "actions": {
      "preparing": "Sipariş: hazırlık",
      "markOnTheWay": "Sipariş: teslimat başladı",
      "delay": "Sipariş: ETA ayarlaması",
      "cancel": "Sipariş: iptal",
      "markDelivered": "Sipariş: teslimat onayı",
      "supportTicket": "Destek: yeni rapor",
      "updateProfile": "Profil: güncelleme",
      "generic": "Güncelleme"
    },
    "technical": {
      "toggle": "Teknik detaylar",
      "itemToggle": "Bu güncellemenin teknik ayrıntıları",
      "pendingCount_one": "Beklemede: {{count}}",
      "pendingCount_other": "Beklemede: {{count}}",
      "failedCount_one": "Geçici hatalar: {{count}}",
      "failedCount_other": "Geçici hatalar: {{count}}",
      "blockedCount_one": "Engellendi: {{count}}",
      "blockedCount_other": "Engellendi: {{count}}",
      "successRate": "Başarı oranı: %{{value}}",
      "attempts": "Denemeler: {{attempts}}/{{maxAttempts}}",
      "priority": "Öncelik: {{value}}",
      "aggregateId": "Referans: {{value}}",
      "lastError": "Teknik hata: {{value}}",
      "stripeNotice": "Stripe ödemeleri: çevrimiçi onay gereklidir."
    },
    "na": "yok"
  },
  "magicImport": {
    "entry": {
      "title": "Kataloğunuzda zaman kazanın",
      "subtitle": "Bir fotoğrafı, PDF'yi veya CSV'yi içe aktarın ve ardından taslağı inceleyin.",
      "cta": "Bir mağazayı içe aktar"
    },
    "title": "Mağazamı oluştur",
    "subtitle": "Yayınlamadan önce zorunlu incelemeyle hızlı oluşturma asistanı.",
    "currentStep": "Adım: {{step}}",
    "steps": {
      "source": "Kaynak seçin",
      "upload": "Dosya yükle",
      "processing": "Analiz",
      "review": "Gözden geçirmek",
      "publish": "Yayınla"
    },
    "source": {
      "description": "Ürün verilerinizin nereden geleceğini seçin.",
      "photo": {
        "label": "Fotoğraf",
        "hint": "Menü, makbuz veya resim"
      },
      "pdf": {
        "label": "PDF'ler",
        "hint": "PDF formatında katalog veya menü"
      },
      "csv": {
        "label": "CSV",
        "hint": "Elektronik tablo veya POS dışa aktarımı"
      }
    },
    "upload": {
      "description": "Bir dosya yükleyin ve ardından otomatik analizi başlatın.",
      "selectedSource": "Seçilen kaynak: {{source}}",
      "fileAria": "Analiz edilecek dosyayı seçin",
      "noFile": "Henüz dosya seçilmedi.",
      "fileMeta": "Yaklaşık. boyut {{size}} KB",
      "previewAlt": "İçe aktarılan belge önizlemesi"
    },
    "processing": {
      "description": "Ürün taslağı hazırlıyoruz. Yayınlamadan önce onaylayacaksınız.",
      "progressLabel": "İlerleme: %{{value}}",
      "currentStage": "Alt adım: {{stage}}",
      "etaSec": "Kalan tahmini süre: {{value}} sn",
      "stages": {
        "upload": "Dosya hazırlama",
        "ocr": "OCR okuma",
        "structuring": "Yapay zeka yapılanması",
        "reviewPrep": "Son kontroller",
        "review": "İnceleme hazır"
      }
    },
    "review": {
      "itemsCount_one": "İncelenecek {{count}} ürün",
      "itemsCount_other": "İncelenecek {{count}} ürün",
      "blockingCount": "{{count}} öğenin onaylanmadan önce düzeltilmesi gerekiyor",
      "noBlockingIssues": "Engelleme sorunu algılanmadı. İncelemeyi onaylayabilirsiniz.",
      "requiredMissingTitle": "Gerekli bilgiler eksik",
      "blockingRow": "Düzeltme gerekli",
      "needsReview": "İncelenmesi gerekiyor",
      "boutique": {
        "title": "Taslağı saklayın",
        "subtitle": "Ürünleri yayınlamadan önce mağaza bilgilerini inceleyin.",
        "fields": {
          "name": "Mağaza adı",
          "category": "Mağaza kategorisi",
          "address": "Mağaza adresi",
          "longitude": "Boylam",
          "latitude": "Enlem"
        },
        "locationReady": "Konum: boylam {{lon}}, enlem {{lat}}",
        "locationMissing": "Konum eksik. Devam etmek için satıcı adresi ayarlarını tamamlayın."
      },
      "required": {
        "missing_name": "Ad gerekli.",
        "missing_category": "Kategori gerekli.",
        "invalid_category": "Geçersiz mağaza kategorisi.",
        "missing_address": "Mağaza adresi gerekli.",
        "missing_location": "Mağaza konumu gerekli.",
        "invalid_price": "Geçersiz ürün fiyatı.",
        "missing_collection_name": "Ürün kategorisi/koleksiyon gereklidir.",
        "invalid_currency": "Desteklenmeyen para birimi (EUR veya MAD).",
        "price_unparsed": "Fiyat otomatik olarak ayrıştırılamadı."
      },
      "fields": {
        "name": "İsim",
        "price": "Fiyat",
        "category": "Ürün koleksiyonu",
        "description": "Tanım"
      },
      "options": {
        "title": "Önerilen seçenekler",
        "single": "Tek seçim",
        "multiple": "Çoktan seçmeli",
        "required": "Gerekli",
        "optional": "İsteğe bağlı",
        "maxSelections": "Maksimum {{count}} seçim(ler)"
      }
    },
    "publish": {
      "readyTitle": "Yayınlanmaya hazır",
      "readyDescription_one": "Taslak {{count}} ürün içeriyor. Şimdi yayınlayabilirsiniz.",
      "readyDescription_other": "Taslak {{count}} ürün içeriyor. Şimdi yayınlayabilirsiniz.",
      "successTitle": "Taslak yayınlandı",
      "successDescription_one": "{{count}} ürünü kataloğunuzda hazır.",
      "successDescription_other": "{{count}} ürün kataloğunuzda hazır.",
      "publishedAt": "{{value}} tarihinde yayınlandı"
    },
    "actions": {
      "close": "Kapalı",
      "back": "Geri",
      "startAnalysis": "Analizi başlat",
      "retry": "Yeniden dene",
      "readyToPublish": "İncelemeyi onayla",
      "publish": "Yayınla",
      "publishing": "Yayınlanıyor...",
      "newImport": "Yeni içe aktarma"
    },
    "status": {
      "analyzing": "Analiz devam ediyor",
      "review": "İncelenmesi gerekiyor",
      "readyToPublish": "Yayınlanmaya hazır",
      "publishing": "Yayınlama",
      "published": "Yayınlandı",
      "failed": "Analiz durduruldu"
    },
    "errors": {
      "sourceRequired": "Devam etmeden önce bir kaynak seçin.",
      "fileRequired": "Başlamak için bir dosya ekleyin.",
      "offline": "Bu içe aktarmayı analiz etmek veya yayınlamak için bağlantı gerekiyor.",
      "adapterUnavailable": "İçe aktarma modülü kullanılamıyor.",
      "analysisFailed": "Analiz başarısız oldu. Lütfen tekrar deneyin.",
      "analysisTooNoisy": "Analiz, güvenilir bir taslak oluşturmak için fazla gürültülüdür. Lütfen daha net bir dosya deneyin.",
      "reviewFailed": "İnceleme onayı başarısız oldu.",
      "reviewBlockingRequired": "İncelemeyi onaylamadan önce gerekli alanları düzeltin.",
      "publishFailed": "Yayınlama başarısız oldu.",
      "publishUnavailable": "Bu taslak yayınlanmaya hazır değil.",
      "publishBlockingRequired": "Zorunlu alanlar düzeltilene kadar yayınlama engellenir.",
      "fileTypeMismatch": "Yüklenen dosya türü seçilen kaynakla eşleşmiyor.",
      "fileUnreadable": "İçe aktarılan dosyaya artık erişilemiyor. Lütfen orijinal belgeyle yeniden başlayın.",
      "quotaExceeded": "Günlük ithalat kotasına ulaşıldı.",
      "noItemsDetected": "Bu dosyada kullanılabilir satır bulunamadı.",
      "generic": "Bir içe aktarma hatası oluştu."
    },
    "confidence": {
      "high": "Yüksek güven (%{{value}})",
      "medium": "Orta düzeyde güven (%{{value}})",
      "low": "Düşük güven (%{{value}})"
    },
    "banner": {
      "offline": "Çevrimdışısınız. Bağlantı geri geldiğinde içe aktarma işlemleri devam eder."
    }
  },
  "gestionProduits": {
    "hiddenBadge": "Gizlenmiş",
    "defaultStoreName": "Mağazanız",
    "loadingProducts": "Ürünler yükleniyor",
    "search": {
      "label": "Ürün ara",
      "placeholder": "Ürün ara..."
    },
    "filters": {
      "all": "Tüm"
    },
    "empty": {
      "searchNoMatch": "Aramanızla eşleşen ürün yok.",
      "noProductsYet": "Bu mağaza için henüz ürün yok.",
      "noStoreSelectedTitle": "Mağaza seçilmedi",
      "noStoreSelectedSubtitle": "Ürünlerinizi yönetmek için yukarıdan bir mağaza seçin.",
      "noStoreImageAlt": "Mağaza seçilmedi"
    },
    "actions": {
      "addStore": "Mağaza ekle",
      "createStore": "Mağaza oluştur",
      "editStore": "Mağazayı düzenle",
      "addProduct": "Ürün ekle",
      "editProduct": "Düzenlemek",
      "showOnStorefront": "Vitrin üzerinde göster",
      "hideFromStorefront": "Vitrin'den gizle",
      "toggleView": "Görünümü değiştir"
    },
    "selector": {
      "deselectStore": "{{name}} seçimini kaldır",
      "storeImageAlt": "{{name}} resmi",
      "deselectStoreAvatar": "{{name}} (avatar) seçimini kaldır",
      "vendorFallback": "Satıcı",
      "avatarAlt": "{{name}} avatarı",
      "storeAria": "{{name}} adlı mağazayı saklayın"
    },
    "confirm": {
      "deleteStoreMessage": "Bu işlem mağazayı kalıcı olarak silecektir. Onaylamak?",
      "deleteStore": "Mağazayı sil",
      "deleting": "Siliniyor..."
    },
    "errors": {
      "loadingProducts": "Ürünler yüklenirken hata oluştu.",
      "saveStoreFailed": "Mağaza kaydetme işlemi başarısız oldu.",
      "deleteStoreFailed": "Mağaza silinirken hata oluştu.",
      "saveProductFailed": "Ürün kaydedilirken hata oluştu.",
      "deleteProductFailed": "Ürün silinirken hata oluştu.",
      "updateVisibilityFailed": "Görünürlük güncellenemiyor."
    },
    "notifications": {
      "reconnect": "Yeniden bağlan",
      "retry": "Yeniden dene",
      "addressSelectionRequired": "Mağazayı bulmak için listeden geçerli bir adres seçin.",
      "addressAmbiguous": "Adres belirsiz. Lütfen kesin bir öneri seçin.",
      "addressNotFound": "Adres bulunamadı. Bir öneri seçin veya yeniden deneyin.",
      "storeSaved": "Mağaza başarıyla kaydedildi.",
      "storeDeleted": "Mağaza silindi.",
      "productUpdated": "Ürün güncellendi.",
      "productAdded": "Ürün eklendi.",
      "productDeleted": "Ürün silindi.",
      "productHidden": "Ürün vitrinden gizlendi.",
      "productVisible": "Ürün tekrar görülüyor.",
      "savePrefix": "Kaydetme başarısız oldu",
      "networkOrServerError": "Ağ veya sunucu hatası."
    }
  },
  "checkout": {
    "saveAddressError": "Bu adres kaydedilemiyor. Lütfen kısa süre sonra tekrar deneyin.",
    "estimateUpdateError": "Teslimat tahmini yenilenemiyor.",
    "loadingUser": "Hesap ayrıntılarınız yükleniyor",
    "missingData": "Bu sipariş onaylanamıyor: eksik veriler.",
    "successPaid": "Ödeme onaylandı. Siparişiniz için teşekkürler.",
    "title": "Sipariş onayı",
    "deliveryAddress": "Teslimat adresi",
    "chooseAddress": "Bir adres seçin",
    "estimateUpdating": "Tahmin güncelleniyor...",
    "changeAddress": "Değiştirmek",
    "orderDetails": "Sipariş ayrıntıları",
    "deliveryFeeLabel": "Teslimat ücreti {{vehicle}} - {{boutique}}",
    "storeFallback": "Mağaza",
    "participationLabel": "{{boutique}} katkı",
    "totalToPay": "Ödenecek toplam",
    "saveAddressPromptTitle": "Sipariş onaylandı - bu adres kaydedilsin mi?",
    "saveAddressPromptDescription": "Böylece bir dahaki sefere tek dokunuşla yeniden kullanabilirsiniz",
    "home": "Ev",
    "work": "İş",
    "later": "Daha sonra"
  },
  "checkoutForm": {
    "paymentGenericError": "Bir ödeme hatası oluştu.",
    "cardInsufficientFunds": "Kart reddedildi: bakiye yetersiz.",
    "cardDeclined": "Kartınız bankanız tarafından reddedildi.",
    "cardInvalidCvc": "Geçersiz CVC. Lütfen kontrol edip tekrar deneyin.",
    "cardExpired": "Bu kartın süresi doldu.",
    "processingGenericError": "Bir işleme hatası oluştu.",
    "preparePaymentError": "Ödeme hazırlanırken hata oluştu.",
    "missingPrerequisites": "Eksik bilgi veya Stripe hazır değil.",
    "addressRequired": "Devam etmek için bir teslimat adresi seçin.",
    "cardFieldMissing": "Kart girişi eksik.",
    "paymentIntentMissing": "Stripe ödeme amacı kimliğini döndürmedi.",
    "unexpectedConfirmError": "Ödeme onayı sırasında beklenmeyen hata.",
    "createOrderError": "Sipariş oluşturulurken hata oluştu.",
    "orderConfirmed": "Sipariş başarıyla onaylandı.",
    "processing": "İşleme...",
    "chooseAddress": "Adres seçin",
    "pay": "Ödemek"
  },
  "deliveryClient": {
    "justNow": "Şu anda",
    "secondsSuffix": "S",
    "minutesSuffix": "dk.",
    "hoursSuffix": "H",
    "ordersCountLabel": "siparişler",
    "emptyOrdersForStatus": "{{status}} sipariş yok.",
    "orderNumber": "Sipariş #{{number}}",
    "placedOn": "{{date}} tarihinde yerleştirildi",
    "placedOnLabel": "Yerleştirme tarihi: {{date}}",
    "orderPaused": "Sipariş duraklatıldı: İşleme geçici olarak durduruldu.",
    "deliverBefore": "{{time}} tarihinden önce teslim edin",
    "driverDelay": "{{value}} dk. rapor edildi",
    "preparationEstimated": "Tahmini hazırlık",
    "minutesValue": "{{value}} dk.",
    "products": "Ürünler",
    "deliveryFee": "Teslimat ücreti",
    "totalPaid": "Toplam ödenen",
    "lastPositionReceived": "Son konum {{age}} önce alındı.",
    "deliveryCode": "Teslimat kodu",
    "cancel": "Siparişi iptal et",
    "cancelling": "İptal...",
    "cancelQueued": "İptal işlemi senkronizasyon için sıraya alındı.",
    "cancelImpossible": "İptal kullanılamıyor.",
    "cancelSuccess": "Sipariş iptal edildi.",
    "tabs": {
      "inProgress": "Devam etmekte",
      "history": "Tarih"
    }
  },
  "deliveryCourier": {
    "noCurrentDelivery": "Güncel teslimat yok",
    "noCurrentDeliveryDescription": "Atanan teslimatlar, sipariş mevcut olur olmaz burada görünecektir.",
    "noDeliveryAlt": "Teslimat yok",
    "goToCourses": "Koşulara git",
    "noDeliveryForStatus": "Bu durum için teslimat yok",
    "noDeliveryForStatusDescription": "Henüz bu filtreyle eşleşen teslimat yok.",
    "badges": {
      "toPickup": "Almak için",
      "toDeliver": "Teslim etmek",
      "paused": "Duraklatıldı"
    },
    "orderNumber": "Sipariş #{{number}}",
    "status": {
      "accepted": "Kabul edildi",
      "preparing": "Hazırlanıyor",
      "onTheWay": "yolda",
      "onHold": "Duraklatıldı"
    },
    "syncPending": "Senkronizasyon beklemede",
    "onHoldNotice": "Sipariş duraklatıldı: Yönetici tarafından yeniden etkinleştirilene veya yeniden atanana kadar hiçbir işlem yapılamaz.",
    "preparationEstimated": "Tahmini hazırlık",
    "minutesValue": "{{value}} dk.",
    "readyAround": "{{time}} civarında hazır",
    "address": "Adres",
    "totalLabel": "Toplam:",
    "store": "Mağaza",
    "client": "Müşteri",
    "unknownNumber": "Bilinmeyen numara",
    "unknownTime": "bilinmiyor",
    "deliverBefore": "{{time}} tarihinden önce teslim edin",
    "delayReported": "{{value}} dk. rapor edildi",
    "delayQuestion": "Gecikme?",
    "minutesPlus": "+{{value}} dk.",
    "processing": "İşleme...",
    "orderPickedUp": "Sipariş alındı",
    "validationCodePlaceholder": "Doğrulama kodu",
    "deliver": "Teslim etmek",
    "tabs": {
      "inProgress": "Devam etmekte",
      "history": "Tarih"
    },
    "deliveryCount_one": "teslimat",
    "deliveryCount_other": "teslimatlar",
    "validationCodeRequired": "Lütfen doğrulama kodunu girin.",
    "actionQueuedOffline": "İşlem çevrimdışına kaydedildi. Otomatik senkronizasyon etkinleştirildi.",
    "orderPickupSuccess": "Sipariş başarıyla alındı",
    "actionImpossible": "İşlem kullanılamıyor.",
    "deliveryQueued": "Teslimat senkronizasyon için sıraya alındı.",
    "deliveryConfirmed": "Teslimat onaylandı",
    "validationImpossible": "Doğrulama başarısız oldu.",
    "paymentUnavailableDoNotDeliver": "Ödeme kullanılamıyor. Teslim etmeyin. Paketi mağazaya iade edin; destek onaylandıktan sonra telafi edecektir.",
    "unexpectedError": "Hata: {{message}}",
    "etaSavedQueued": "ETA kaydedildi ({{value}} dk), senkronizasyon bekleniyor.",
    "etaAdjusted": "ETA ayarlandı ({{value}} dk.)",
    "adjustImpossible": "Ayarlama kullanılamıyor",
    "incidentTitle": "Sipariş iptal edildi - ödeme yapılamıyor",
    "todoTitle": "yapmak",
    "todoNoDeliver": "Müşteriye teslim etmeyin.",
    "todoReturnPackage": "Paketi mağazaya iade edin.",
    "todoSupportCompensation": "Destek, mağaza onayından sonra telafi edecektir.",
    "reportSent": "Rapor desteğe gönderildi.",
    "reportError": "Raporlama sırasında hata oluştu.",
    "reportSentDone": "Rapor gönderildi",
    "sending": "Gönderiliyor...",
    "reportIncident": "Olayı bildir",
    "backToFlow": "Akışa geri dön",
    "storeLabel": "Mağaza: {{value}}",
    "clientLabel": "Müşteri: {{value}}",
    "courierTotal": "Kurye toplamı: {{amount}}",
    "avatarAltStore": "{{value}} avatarı",
    "avatarAltClient": "{{value}} avatarı"
  },
  "deliveryVendor": {
    "justNow": "Şu anda",
    "secondsSuffix": "S",
    "minutesSuffix": "dk.",
    "hoursSuffix": "H",
    "status": {
      "accepted": "Kabul edildi",
      "onHold": "beklemede",
      "preparing": "Tedarikli",
      "onTheWay": "Teslimat için çıktı",
      "delivered": "Teslim edilmiş",
      "cancelled": "İptal edildi"
    },
    "incidentTitle": "Sipariş iptal edildi",
    "incidentDefaultMessage": "Ödeme kullanılamıyor. Siparişi hazırlamayın.",
    "todoTitle": "yapmak",
    "todoNoPrepare": "Hazırlamayın/göndermeyin.",
    "todoInformCourier": "Gerektiğinde kargo görevlisine siparişin iptal edildiğini bildirin.",
    "understood": "Anlaşıldı",
    "preparationTime": "Hazırlık süresi",
    "preparationHint": "Müşteri ve kurye için bir tahmin belirleyin.",
    "cancel": "İptal etmek",
    "actionQueuedOffline": "İşlem çevrimdışına kaydedildi. Otomatik senkronizasyon.",
    "incidentPaymentUnavailable": "Sipariş iptal edildi: ödeme yapılamıyor. Hazırlık yapmayın.",
    "actionImpossible": "İşlem kullanılamıyor.",
    "validate": "Onaylamak",
    "emptyForStatus": "{{status}} sipariş yok",
    "emptyText": {
      "accepted": "Müşteri sipariş verir vermez siparişler burada görünecektir.",
      "onHold": "Duraklatılan siparişler burada görünecektir.",
      "preparing": "Henüz herhangi bir siparişi hazırlanıyor olarak işaretlemediniz.",
      "onTheWay": "Teslimata gönderilen siparişler burada görünecektir.",
      "delivered": "Henüz teslim edildi olarak işaretlenen bir sipariş yok.",
      "cancelled": "Yakın zamanda herhangi bir siparişi iptal etmediniz."
    },
    "noOrderAlt": "Sipariş yok",
    "orderNumber": "Sipariş #{{number}}",
    "unknownStatus": "Bilinmeyen durum",
    "syncPending": "Senkronizasyon beklemede",
    "lastPositionReceived": "Son konum {{age}} önce alındı.",
    "onHoldNotice": "Sipariş duraklatıldı: İşleme askıya alındı ​​(etkin olmayan hesap veya yeniden atama devam ediyor).",
    "clientPromise": "Müşteri ETA vaadi: {{time}}",
    "driverDelay": "{{value}} dk. rapor edildi",
    "preparationEstimated": "Tahmini hazırlık",
    "minutesValue": "{{value}} dk.",
    "readyAround": "{{time}} civarında hazır",
    "products": "Ürünler",
    "deliveryFee": "Teslimat ücreti",
    "riveltimeCommission": "Riveltime komisyonu",
    "vendorNet": "Satıcı ağı",
    "deliverer": "Kurye",
    "avatarAlt": "{{value}} avatarı",
    "client": "Müşteri",
    "cancelQueued": "İptal işlemi senkronizasyon için sıraya alındı.",
    "cancelImpossible": "İptal kullanılamıyor.",
    "markPreparing": "Hazırlanışı işaretle",
    "storeFilterLabel": "Mağaza",
    "storeFilterAll": "Tüm",
    "unknownStore": "Bilinmeyen mağaza"
  },
  "orderCard": {
    "orderNumber": "Sipariş #{{id}}",
    "placedOn": "{{date}} tarihinde yerleştirildi",
    "store": "Mağaza",
    "deliveryFee": "Teslimat ücreti",
    "vendorContribution": "Satıcı katkısı",
    "storeTotal": "Toplam mağaza",
    "paymentStatusLabel": "Ödeme durumu:",
    "deliveryStatusLabel": "Teslimat durumu:",
    "orderTotal": "Sipariş toplamı:",
    "paymentStatus": {
      "authorized": "Yetkili",
      "succeeded": "Paralı",
      "canceled": "İptal edildi",
      "failed": "Arızalı",
      "unknown": "Bilinmiyor"
    },
    "deliveryStatus": {
      "pending": "Askıda olması",
      "accepted": "Kabul edildi",
      "preparing": "Hazırlanıyor",
      "on_the_way": "yolda",
      "delivered": "Teslim edilmiş",
      "cancelled": "İptal edildi",
      "on_hold": "beklemede",
      "unknown": "Bilinmiyor"
    }
  },
  "userForm": {
    "fullname": "Ad Soyad",
    "phone": "Telefon",
    "phoneTitle": "Geçerli bir telefon numarası girin (7 ila 15 haneli)",
    "fullAddress": "Tam adres",
    "addressPlaceholder": "Bir adres girin",
    "category": "Kategori",
    "selectCategory": "-- Bir kategori seçin --",
    "categories": {
      "alimentation": "Yiyecek",
      "mobiliteElectrique": "Elektrikli hareketlilik",
      "pretAPorter": "Moda",
      "informatique": "BT",
      "restaurantTraiteur": "Restoran / Catering",
      "pharmacieSante": "Eczane / Sağlık",
      "bricolageMaison": "Kendin Yap / Ev",
      "fleuristeJardin": "Çiçekçi / Bahçe"
    },
    "transportType": "Taşıma türü",
    "selectTransport": "-- Taşımayı seçin --",
    "transports": {
      "bike": "Bisiklet",
      "scooter": "Scooter",
      "car": "Araba",
      "truck": "Kamyon",
      "walk": "yürüyerek"
    },
    "save": "Bilgilerimi kaydet",
    "errors": {
      "noAddressSuggestion": "Öneri bulunamadı",
      "searchError": "Arama hatası"
    }
  },
  "orderMutations": {
    "actionQueuedOffline": "İşlem çevrimdışına kaydedildi.",
    "orderNotFound": "Sipariş bulunamadı.",
    "preparingError": "Hazırlanıyor olarak işaretlenemedi",
    "onTheWayError": "Yolda olarak işaretlenemedi",
    "invalidDelta": "Geçersiz delta",
    "adjustEtaError": "ETA ayarlanamadı",
    "missingCode": "Eksik kod",
    "deliveryQueued": "Teslimat senkronizasyon için kuyruğa alındı.",
    "deliveryError": "Teslimat başarısız oldu",
    "cancelError": "İptal başarısız oldu"
  },
  "adminCatalogue": {
    "title": "Mağazalar ve Ürünler",
    "subtitle": "Filtreler ve hızlı eylemler içeren genel katalog.",
    "tabs": {
      "stores": "Mağazalar",
      "products": "Ürünler"
    },
    "searchPlaceholder": "Arama (isim, mağaza, satıcı, e-posta)",
    "loading": "Yükleniyor",
    "vendorFallback": "Satıcı",
    "storeFallback": "Mağaza",
    "storeClosure": "Kapatma",
    "hidden": "Gizlenmiş",
    "emptyStores": "Mağaza yok.",
    "emptyProducts": "Ürün yok.",
    "errors": {
      "load": "Katalog yüklenemiyor.",
      "updateStore": "Mağaza güncellenemiyor.",
      "updateProduct": "Ürün güncellenemiyor."
    }
  },
  "liveSocket": {
    "inactiveVendor": "Aktif olmayan hesap: Mağazalarınız gizlenir ve siparişleriniz engellenir.",
    "inactiveCourier": "Etkin olmayan hesap: Hesap yeniden etkinleştirilene kadar hiçbir çalıştırma mevcut değildir.",
    "reactivated": "Hesap yeniden etkinleştirildi.",
    "deactivated": "Hesap devre dışı bırakıldı.",
    "realtimeUnavailableSubscription": "Gerçek zamanlı kullanılamıyor (pozisyon aboneliği)",
    "retry": "Yeniden dene",
    "diagnosticCopied": "Teşhis kopyalandı",
    "copyDiagnosticPrompt": "Bu tanılamayı kopyalayın:",
    "diagnosticTitle": "Socket.IO Teşhisi",
    "diagnosticDescription": "Oylamanın neden başarısız olduğunu belirlemek için bu bloğu (ekran görüntüsü veya kopya) paylaşın.",
    "close": "Kapalı",
    "copy": "Kopyala",
    "ok": "TAMAM",
    "originHintNetlify": "Ön taraf {{origin}} yönüne dönüyor. API URL değişkenini ve CORS kurallarını kontrol eder.",
    "inferred": {
      "blockedOrNoResponse": "Arka uçtan (ağ, proxy veya CORS) yanıt yok.",
      "endpointNotFound": "Uç Nokta Soketi bulunamadı (yol/proxy).",
      "forbidden": "Erişim reddedildi (CORS veya güvenlik kuralı).",
      "unauthorized": "Kimlik doğrulama reddedildi (geçersiz/süresi dolmuş belirteç).",
      "proxyUnavailable": "Sunucu geçici olarak kullanılamıyor (5xx)."
    }
  },
  "userStore": {
    "emailAlreadyLinkedOtherAccount": "Bu e-posta adresi zaten başka bir hesaba bağlı. Doğru yöntemle oturum açın veya bir oturum açma bağlantısı isteyin.",
    "unableToFetchProfile": "Profil alınamıyor.",
    "invalidSessionReconnect": "Geçersiz oturum. Yeniden bağlanın.",
    "deleteAccountFailed": "Hesap silinemedi.",
    "unexpectedError": "Beklenmeyen hata."
  },
  "apiErrors": {
    "unknown": "Beklenmeyen bir hata oluştu.",
    "codes": {
      "ACTIVE_ORDERS": "Silme işlemi engellendi: Aktif siparişler hâlâ mevcut.",
      "ACCOUNT_DELETED_OR_MISSING": "Hesap eksik veya silinmiş. Tekrar oturum açın.",
      "EMAIL_NOT_VERIFIED": "Devam etmek için e-posta adresinizi doğrulayın.",
      "INVALID_TOKEN": "Geçersiz oturum. Tekrar oturum açın.",
      "SESSION_EXPIRED": "Oturumun süresi doldu. Tekrar oturum açın.",
      "SUPPORT_COOLDOWN": "Çok hızlı gönderiyorsunuz. Birkaç saniye sonra tekrar deneyin.",
      "SUPPORT_RATE_LIMIT_USER": "Çok fazla yeni rapor var. Lütfen daha sonra tekrar deneyin.",
      "SUPPORT_RATE_LIMIT_IP": "Bu bağlantı için rapor sınırına ulaşıldı. Lütfen daha sonra tekrar deneyin.",
      "PRELAUNCH_EMAIL_INVALID": "Geçersiz e-posta adresi.",
      "PRELAUNCH_SUBSCRIBE_FAILED": "Şu anda abone olunamıyor.",
      "LINK_SESSION_INVALID": "Geçersiz bağlantı oturumu.",
      "LINK_SESSION_EXPIRED": "Bağlantı oturumunun süresi doldu. Tekrar başla.",
      "LINK_CONFIRMATION_REQUIRED": "Bu oturum açma yöntemlerini bağlamak için onay gereklidir.",
      "LINK_FORBIDDEN": "Bu istek için hesap bağlamaya izin verilmiyor.",
      "LINK_FAILED": "Oturum açma yöntemlerinin bağlantısı tamamlanamadı.",
      "LINK_ALREADY_DONE": "Bu oturum açma yöntemleri zaten bağlantılı.",
      "LINK_RATE_LIMITED": "Çok fazla bağlantı denemesi yapıldı. Kısa süre sonra tekrar deneyin.",
      "AMBASSADOR_DETACH_FAILED": "Hesap silme işlemi şu anda tamamlanamıyor. Lütfen tekrar deneyin veya yönetici desteğiyle iletişime geçin.",
      "INVALID_TARGET_AMBASSADOR": "Hedef elçi geçersiz veya kullanılamıyor.",
      "VENDOR_ALREADY_ASSIGNED_TO_TARGET": "Bu satıcı zaten bu elçiye bağlı.",
      "VENDOR_IDS_REQUIRED": "Aktarım için satıcı seçimi gereklidir.",
      "VENDOR_BULK_LIMIT_EXCEEDED": "Toplu aktarım için çok fazla satıcı seçildi.",
      "VENDOR_REASSIGN_BULK_FAILED": "Toplu aktarım başarısız oldu.",
      "ORDER_CANCEL_CLIENT_PENDING_ONLY": "Yalnızca beklemede olan bir siparişi iptal edebilirsiniz.",
      "ORDER_PAYMENT_CAPTURED_CANCEL_IMPOSSIBLE": "Ödeme zaten kaydedildi: iptal işlemi mümkün değil.",
      "ORDER_CANCEL_FORBIDDEN": "Bu siparişi iptal etmenize izin verilmiyor.",
      "ORDER_CANCEL_VENDOR_INACTIVE": "Etkin olmayan hesap: iptal engellendi.",
      "ORDER_CANCEL_SERVER_ERROR": "Sipariş iptal edilirken sunucu hatası oluştu."
    }
  },
  "addressSheet": {
    "home": "Ev",
    "work": "İş",
    "searchError": "Adres aranamıyor. Bağlantınızı kontrol edin.",
    "geoUnavailable": "Konum kullanılamıyor - bir adres yazın.",
    "geoDenied": "Konum reddedildi - bir adres yazabilirsiniz.",
    "myLocation": "Konumum",
    "myLocationFast": "Konumum (en hızlı)",
    "addressFallback": "Adres",
    "mapSelectedPoint": "Seçilen nokta",
    "mapUnavailable": "Harita bu cihazda kullanılamıyor.",
    "searchPlaceholder": "Adres, şehir, ülke",
    "searchAria": "Adres arayın",
    "searching": "Arama...",
    "noResults": "Sonuç yok. Numara + sokak + şehri deneyin.",
    "locating": "Bulunuyor...",
    "howToEnable": "Nasıl etkinleştirilir?",
    "adjustMap": "Haritada ayarla",
    "title": "Teslimat adresi",
    "description": "Ücreti ve ETA'yı hesaplamak için gereklidir.",
    "currentAddress": "Güncel: {{label}}",
    "chooseForEstimate": "Teslimatı tahmin etmek için bir adres seçin",
    "emptyRecents": "Kayıtlı adresleriniz burada görünecek.",
    "mapLoadingAria": "Harita yükleniyor",
    "back": "Geri",
    "confirmPoint": "Bu noktayı onaylayın"
  },
  "locationModal": {
    "title": "Konumu etkinleştir",
    "body": "\"Konumum\"u kullanmak için konum erişimine izin verin. Aksi halde bir adres yazın.",
    "iosTitle": "iPhone (PWA / Safari / Chrome)",
    "iosStep1": "Ayarlar'ı açın.",
    "iosStep2": "Safari veya Chrome'u seçin.",
    "iosStep3": "Konumu Aç.",
    "iosStep4": "\"Uygulamayı Kullanırken\" seçeneğini seçin.",
    "iosStep5": "Riveltime'a dönün ve tekrar deneyin.",
    "androidTitle": "Android / Masaüstü",
    "androidStep1": "Adres çubuğundaki kilit simgesini tıklayın.",
    "androidStep2": "Site ayarlarını açın.",
    "androidStep3": "İzin verilecek konumu ayarlayın.",
    "androidStep4": "Gerekirse sayfayı yeniden yükleyin.",
    "later": "Daha sonra",
    "wait": "Lütfen bekleyin...",
    "retry": "Yeniden dene"
  },
  "admin": {
    "pageTitle": "Hesaplar",
    "pageSubtitle": "Müşteriler, satıcılar, kuryeler: onay ve kontrol.",
    "emptyTitle": "Kullanıcı yok",
    "emptySubtitle": "Aramayı veya filtreleri ayarlayın.",
    "retry": "Yeniden dene",
    "searchPlaceholder": "Hesapta ara (ad veya e-posta)...",
    "searchAria": "Hesap ara",
    "clearSearch": "Aramayı temizle",
    "deleteConfirm": "Bu eylem geri döndürülemez. Hesabın silinmesini onaylıyor musunuz?",
    "unknownName": "Bilinmeyen ad",
    "accountValidated": "Hesap onaylandı",
    "account": "Hesap",
    "close": "Kapalı",
    "closeAria": "Hesap modunu kapat",
    "activeStatus": "Aktif durum",
    "activeToggleAria": "Bu hesabı etkinleştirin veya devre dışı bırakın",
    "active": "Aktif",
    "inactive": "Etkin değil",
    "createdOn": "Oluşturulma tarihi",
    "phone": "Telefon",
    "approving": "Onaylanıyor...",
    "updating": "Güncelleniyor...",
    "deleteDisabledForAdmin": "Yönetici silme işlemi engellendi.",
    "feedback": {
      "approveSuccess": "Hesap başarıyla onaylandı.",
      "activateSuccess": "Hesap başarıyla etkinleştirildi.",
      "deactivateSuccess": "Hesap başarıyla devre dışı bırakıldı."
    },
    "accountHolder": {
      "title": "Hesap sahibi",
      "subtitle": "Hesap sahibinin adını ve soyadını girin.",
      "firstName": "İlk adı",
      "lastName": "Soy isim",
      "firstNamePlaceholder": "Örn: Amira",
      "lastNamePlaceholder": "Örn: Fkir",
      "firstNameRequired": "Ad gereklidir.",
      "lastNameRequired": "Soyadı gerekli.",
      "save": "Kaydetmek",
      "saving": "Kaydediliyor...",
      "updateSuccess": "Hesap sahibi güncellendi.",
      "updateError": "Hesap sahibi güncellenemiyor."
    },
    "approve": "Onaylamak",
    "ok": "TAMAM",
    "delete": "Silmek",
    "transfer": {
      "title": "Satıcıları aktar",
      "subtitle": "Zorunlu bir nedenden dolayı bir satıcıyı başka bir elçiye yeniden atayın.",
      "actions": {
        "enableMode": "Aktarım modu",
        "disableMode": "Çıkış modu",
        "processing": "İşleme..."
      },
      "filters": {
        "sourceAmbassador": "Kaynak elçisi",
        "sourceAll": "Tüm elçiler",
        "sourceUnassigned": "Atanmamış satıcılar",
        "handover": "Devretmek",
        "handoverAll": "Tüm",
        "handoverPending": "Askıda olması",
        "handoverNotPending": "İşlendi"
      },
      "bulk": {
        "targetLabel": "Yeni büyükelçi",
        "targetPlaceholder": "Bir elçi seçin",
        "reasonLabel": "Aktarım nedeni",
        "reasonPlaceholder": "Örn: yerel iş sürekliliği",
        "selectAllVisible": "Görünür satıcıları seçin",
        "clearSelection": "Seçimi temizle",
        "submit": "Aktarım ({{count}})",
        "selectVendor": "Satıcıyı seçin",
        "unselectVendor": "Satıcıyı seçimden kaldır"
      },
      "single": {
        "title": "Bu satıcıyı aktar",
        "subtitle": "Aktarım, doğrulama durumunu değiştirmeden ağ bağlantısını günceller.",
        "currentAmbassador": "Mevcut büyükelçi",
        "targetLabel": "Hedef elçi",
        "targetPlaceholder": "Bir elçi seçin",
        "reasonLabel": "Sebep",
        "reasonPlaceholder": "Zorunlu sebep",
        "submit": "Aktarım satıcısı",
        "noAmbassadorAvailable": "Bu transfer için herhangi bir elçi mevcut değil."
      },
      "labels": {
        "unassigned": "Atanmamış"
      },
      "errors": {
        "targetRequired": "Lütfen bir hedef elçi seçin.",
        "reasonRequired": "Neden gereklidir (minimum 3 karakter)."
      },
      "confirm": {
        "message": "{{count}} tedarikçinin/tedarikçilerin aktarımı onaylansın mı? Sebep: {{reason}}",
        "confirm": "Onaylamak",
        "cancel": "İptal etmek",
        "processing": "Aktarılıyor..."
      },
      "feedback": {
        "selectionRequired": "En az bir satıcı seçin.",
        "targetRequired": "Bir hedef elçi seçin.",
        "singleSuccess": "Satıcı başarıyla aktarıldı.",
        "singleError": "Bu satıcı aktarılamıyor.",
        "bulkSuccess": "{{count}} satıcı(lar) başarıyla aktarıldı.",
        "bulkPartial": "{{success}} aktarım başarılı oldu, {{failed}} başarısız oldu.",
        "bulkError": "Toplu aktarım başarısız oldu."
      }
    },
    "roles": {
      "all": "Tüm",
      "client": "Müşteriler",
      "vendeur": "Satıcılar",
      "livreur": "Kuryeler",
      "admin": "Yönetici",
      "ambassadeur": "Büyükelçiler",
      "unknown": "Bilinmiyor"
    },
    "status": {
      "approved": "Onaylı",
      "pending": "Askıda olması",
      "suspended": "Askıya alınmış",
      "unknown": "Bilinmiyor"
    },
    "errors": {
      "loadUsers": "Kullanıcılar yüklenemiyor. Lütfen tekrar deneyin.",
      "approveUser": "Kullanıcı onaylanırken hata oluştu.",
      "toggleActive": "Etkin durum değiştirilemiyor.",
      "deleteUser": "Kullanıcı silinirken hata oluştu."
    }
  },
  "ambassador": {
    "dashboard": {
      "title": "Büyükelçi kontrol paneli",
      "subtitle": "Yerel ağ performansınızı takip edin.",
      "kpis": {
        "sectionTitle": "Küresel KPI'lar",
        "monthlyRevenue": "Aylık gelir",
        "ordersCount": "Sipariş sayısı",
        "averageBasket": "Ortalama sepet",
        "growthRate": "Büyüme oranı",
        "ambassadorCommission": "Oluşturulan komisyon (%4)",
        "total": "Toplam ağ",
        "inReview": "İnceleniyor",
        "certified": "Sertifikalı",
        "restricted": "Sınırlı"
      },
      "period": {
        "label": "Dönem"
      },
      "search": {
        "label": "Hızlı arama",
        "placeholder": "Ad, e-posta veya telefon",
        "cta": "Hesaplarda ara"
      },
      "actions": {
        "refresh": "Yenile",
        "openNetwork": "Bir satıcıyı entegre edin",
        "manageNetwork": "Ağımı yönet"
      },
      "activity": {
        "title": "Son etkinlik",
        "empty": "Henüz yeni bir etkinlik yok.",
        "statusPrefix": "İşlem: {{status}}"
      },
      "activityKinds": {
        "preparing": "Profil hazırlanıyor",
        "in_review": "Hesap inceleniyor",
        "certified": "Satıcı sertifikalı",
        "restricted": "Hesap kısıtlandı",
        "unknown": "Güncelleme"
      },
      "states": {
        "loading": "KPI verileri yükleniyor...",
        "retry": "Yeniden dene"
      },
      "labels": {
        "na": "Sağlanmadı",
        "unknownDate": "Tarih mevcut değil"
      },
      "feedback": {
        "loadError": "Kontrol paneli KPI'ları yüklenemiyor."
      }
    },
    "network": {
      "title": "Satıcı ağı",
      "subtitle": "Yalnızca satıcının ağ entegrasyon kodunu kullanın.",
      "form": {
        "title": "Ağınıza bir satıcı ekleyin",
        "whereToFind": "Satıcı bu kodu Profil, Kod oluştur bölümünde bulabilir.",
        "claimCodeLabel": "Satıcı kodu (6 haneli)",
        "claimCodePlaceholder": "Örn: 493821",
        "claimCodeHint": "Yalnızca 6 haneyi girin.",
        "resolve": "Kodu doğrula",
        "resolving": "Doğrulanıyor..."
      },
      "states": {
        "loading": "Kod kontrol ediliyor...",
        "success": "Kod geçerlidir. Satıcı sertifikasyona hazır.",
        "error": "Bu kod doğrulanamıyor.",
        "expired": "Kodun süresi doldu. Satıcıdan onu yeniden oluşturmasını isteyin.",
        "used": "Kod zaten kullanıldı. Yeni bir kod isteyin."
      },
      "preview": {
        "title": "Satıcı önizlemesi",
        "vendorLabel": "Satıcı",
        "emailLabel": "E-posta",
        "phoneLabel": "Telefon",
        "accountStatusLabel": "Hesap durumu",
        "verificationStatusLabel": "Doğrulama durumu",
        "activityLabel": "Görünürlük",
        "mainBoutiqueLabel": "Ana mağaza",
        "completenessLabel": "Tamlık",
        "claimExpiresAtLabel": "Kodun süresi doluyor",
        "resolutionExpiresAtLabel": "Oturumun süresi doluyor"
      },
      "labels": {
        "na": "Sağlanmadı"
      },
      "activity": {
        "active": "Aktif",
        "inactive": "Etkin değil"
      },
      "verificationStatus": {
        "preparing": "Hazırlanıyor",
        "in_review": "İnceleniyor",
        "certified": "Sertifikalı",
        "restricted": "Sınırlı",
        "unknown": "Bilinmiyor"
      },
      "accountStatus": {
        "pending": "Askıda olması",
        "approved": "Onaylı",
        "suspended": "Askıya alınmış",
        "unknown": "Bilinmiyor"
      },
      "actions": {
        "certify": "Sertifikala",
        "certifying": "Sertifikalandırılıyor...",
        "requestCorrection": "Düzeltme iste",
        "requestingCorrection": "Talep ediliyor...",
        "restrict": "Kısıtlamak",
        "restricting": "Kısıtlanıyor..."
      },
      "restrict": {
        "reasonLabel": "Kısıtlama nedeni",
        "reasonPlaceholder": "Bu hesabın neden kısıtlanması gerektiğini açıklayın"
      },
      "feedback": {
        "codeRequired": "Devam etmek için bir satıcı kodu girin.",
        "resolveSuccess": "Satıcı bulundu. Artık sertifikayı onaylayabilirsiniz.",
        "resolveError": "Bu satıcı kodu çözülemiyor.",
        "certifySuccess": "Satıcı sertifikalı ve ağınızda etkinleştirilmiş.",
        "certifyError": "Sertifikasyon başarısız oldu.",
        "correctionSuccess": "Hesap, tedarikçi güncellemelerini bekleyen düzeltmeye ayarlandı.",
        "correctionError": "Düzeltme isteği yapılamıyor.",
        "restrictSuccess": "Hesap başarıyla kısıtlandı.",
        "restrictError": "Bu hesap kısıtlanamıyor.",
        "restrictReasonRequired": "Kısıtlama nedeni gerekli.",
        "vendorMissing": "Satıcı seçilmedi."
      }
    },
    "accounts": {
      "title": "Ağım",
      "subtitle": "Satıcılarınızı basit ve hızlı eylemlerle yönetin.",
      "count": "{{count}} satıcı",
      "scopeNotice": "Yalnızca kendi ağınızdaki satıcıları görürsünüz.",
      "filters": {
        "searchLabel": "Satıcı arama",
        "searchPlaceholder": "Ad, e-posta veya telefon",
        "quick": {
          "all": "Tüm",
          "in_review": "İnceleniyor",
          "certified": "Sertifikalı",
          "restricted": "Sınırlı",
          "inactive": "Etkin değil"
        },
        "statusLabel": "Hesap durumu",
        "verificationLabel": "Doğrulama durumu",
        "activeLabel": "Aktif durum",
        "status": {
          "all": "Tüm",
          "pending": "Askıda olması",
          "approved": "Onaylı",
          "suspended": "Askıya alınmış"
        },
        "verification": {
          "all": "Tüm",
          "preparing": "Hazırlanıyor",
          "inReview": "İnceleniyor",
          "certified": "Sertifikalı",
          "restricted": "Sınırlı"
        },
        "active": {
          "all": "Tüm",
          "active": "Aktif",
          "inactive": "Etkin değil"
        }
      },
      "actions": {
        "applyFilters": "Uygula",
        "resetFilters": "Sıfırla",
        "refresh": "Yenile",
        "reactivate": "Hesabı yeniden etkinleştirin",
        "suspend": "Hesabı askıya al",
        "activate": "Hesabı etkinleştir",
        "deactivate": "Hesabı devre dışı bırak",
        "unrestrict": "Kaldırma kısıtlaması",
        "details": "Detaylar",
        "hideDetails": "Saklamak",
        "restrict": "Hesabı kısıtla",
        "consequences": {
          "reactivate": "Satıcı tekrar görünür hale gelir.",
          "suspend": "Hesap düzeltilinceye kadar askıya alınmıştır.",
          "activate": "Satıcı tekrar görünür hale gelir.",
          "deactivate": "Satıcı gizlenir.",
          "unrestrict": "Satıcı tekrar faaliyete geçer.",
          "restrict": "Hesap düzeltilinceye kadar askıya alınmıştır."
        }
      },
      "list": {
        "title": "Ağ satıcıları",
        "statusLine": "{{status}} • {{verification}}",
        "mainBoutiqueFallback": "Ana mağaza sağlanmadı"
      },
      "states": {
        "loading": "Hesaplar yükleniyor...",
        "empty": "Bu filtrelerle eşleşen satıcı yok.",
        "emptyDescription": "Ağınız şimdilik boş. Başlamak için satıcıları ekleyin.",
        "emptyAlt": "Satıcı yok",
        "emptyCta": "Satıcı ekle",
        "retry": "Yeniden dene"
      },
      "details": {
        "title": "Hesap ayrıntıları",
        "sheetTitle": "Satıcı ayrıntıları",
        "sheetSubtitle": "Bir eylemi onaylamadan önce bilgileri inceleyin.",
        "identityBlock": "Satıcı kimliği",
        "restrictionBlock": "Kısıtlama bağlamı",
        "vendorId": "E-posta",
        "phone": "Telefon",
        "mainBoutique": "Ana mağaza",
        "name": "İsim",
        "status": "Hesap durumu",
        "verification": "Doğrulama",
        "activity": "Aktif durum",
        "lastUpdate": "Son güncelleme",
        "restrictReason": "Kısıtlama nedeni",
        "restrictReasonNone": "Aktif kısıtlama nedeni yok."
      },
      "restrict": {
        "reasonLabel": "Kısıtlama nedeni",
        "reasonPlaceholder": "Bu hesabın nedenini belirtin",
        "templates": {
          "missingInfo": "Eksik bilgi",
          "lowQuality": "Düşük kalite",
          "prohibited": "Yasaklanmış ürünler"
        }
      },
      "confirm": {
        "actionMessage": "{{vendor}} için işlem onaylansın mı? {{consequence}}",
        "restrictMessage": "{{vendor}} için kısıtlama onaylansın mı? {{consequence}} Sebep: {{reason}}",
        "confirm": "Onaylamak",
        "cancel": "İptal etmek",
        "processing": "İşleme..."
      },
      "badges": {
        "status": {
          "pending": "Askıda olması",
          "approved": "Onaylı",
          "suspended": "Askıya alınmış",
          "unknown": "Bilinmiyor"
        },
        "verification": {
          "preparing": "Hazırlanıyor",
          "in_review": "İnceleniyor",
          "certified": "Sertifikalı",
          "restricted": "Sınırlı",
          "unknown": "Bilinmiyor"
        },
        "active": {
          "active": "Aktif",
          "inactive": "Etkin değil"
        }
      },
      "labels": {
        "na": "Sağlanmadı",
        "unknownDate": "Tarih mevcut değil"
      },
      "feedback": {
        "loadError": "Ağ hesapları yüklenemiyor.",
        "reactivateSuccess": "Hesap başarıyla yeniden etkinleştirildi.",
        "reactivateError": "Bu hesap yeniden etkinleştirilemiyor.",
        "suspendSuccess": "Hesap başarıyla askıya alındı.",
        "suspendError": "Bu hesap askıya alınamıyor.",
        "activateSuccess": "Hesap başarıyla etkinleştirildi.",
        "deactivateSuccess": "Hesap başarıyla devre dışı bırakıldı.",
        "unrestrictSuccess": "Kısıtlama başarıyla kaldırıldı.",
        "activeError": "Etkin durum değiştirilemiyor.",
        "restrictReasonRequired": "Kısıtlama nedeni gerekli.",
        "restrictSuccess": "Hesap başarıyla kısıtlandı.",
        "restrictError": "Bu hesap kısıtlanamıyor."
      }
    }
  },
  "profile": {
    "syncQueuedOffline": "Güncelleştirme çevrimdışı olarak kaydedildi. Otomatik olarak senkronize edilecektir.",
    "updateSuccess": "Profil başarıyla güncellendi.",
    "updateFailed": "Profil güncellemesi başarısız oldu.",
    "addressNotFound": "Adres bulunamadı. Lütfen daha kesin bir adres girin veya bir öneri seçin.",
    "geocodeFailed": "Coğrafi kodlama hatası. İnternet bağlantınızı kontrol edin.",
    "languageQueuedOffline": "Dil yerel olarak güncellendi. Çevrimiçi olduğunda senkronize edilecektir.",
    "languageUpdated": "Dil güncellendi.",
    "languageUpdateFailed": "Dil güncellenemiyor.",
    "redirecting": "Yönlendiriliyor...",
    "sessionInvalid": "Geçersiz oturum - tekrar oturum açın.",
    "incompleteWarning": "Profiliniz eksik. Lütfen tamamlayın.",
    "fullnamePlaceholder": "Ad Soyad",
    "phonePlaceholder": "Telefon",
    "phoneTitle": "Geçerli bir telefon numarası girin (7 - 15 rakam, boşluk ve tirelere izin verilir)",
    "addressPlaceholder": "Tam adres",
    "transportPlaceholder": "-- Taşımayı seçin --",
    "save": "Kaydetmek",
    "edit": "Düzenlemek",
    "complete": "Tamamlamak",
    "editInfo": "Bilgilerimi düzenle",
    "infoTitleCompact": "Bilgi",
    "notificationsByEmail": "E-posta bildirimleri alın",
    "languageHint": "Uygulama dilini seçin.",
    "languageUpdating": "Güncelleniyor...",
    "languageImmediate": "Değişiklik bu cihazda hemen uygulanır.",
    "supportDescription": "Bir sorunu 30 saniyeden kısa sürede bildirin. Hedef yanıt 24 iş saati içinde.",
    "supportCta": "Bir sorunu bildirin",
    "securityChangePassword": "Şifremi değiştir",
    "passwordResetRequesting": "Gönderiliyor...",
    "passwordResetRequestSent": "Bir şifre sıfırlama e-postası gönderildi.",
    "passwordResetRequestFailed": "Şifre sıfırlama e-postası gönderilemiyor.",
    "passwordResetMissingEmail": "E-posta adresi kullanılamıyor.",
    "accepted": "Kabul edildi",
    "onDate": "{{date}} tarihinde",
    "viewOnly": "Görüntülendi",
    "supportTicketSent": "#{{id}} numaralı destek bileti gönderildi.",
    "notProvided": "Sağlanmadı",
    "fullnameLockedByLegal": "Yasal şartlar imzalandıktan sonra tam ad kilitlenir.",
    "emailManagedByProvider": "Bu e-posta adresi giriş sağlayıcınız tarafından yönetilmektedir.",
    "infoStatus": {
      "complete": "Profil tamamlandı",
      "incomplete": "Eksik bilgi",
      "actionRequired": "İşlem gerekli"
    },
    "emailStatus": {
      "verified": "E-posta doğrulandı",
      "pending": "Doğrulamak için e-posta",
      "provider": "Sağlayıcı tarafından yönetilen e-posta"
    },
    "infoLabels": {
      "fullname": "Ad Soyad",
      "email": "E-posta adresi",
      "phone": "Telefon",
      "address": "Adres",
      "transport": "Taşıma",
      "certificationStatus": "Satıcı sertifika durumu"
    },
    "infoSheet": {
      "title": "Bilgilerimi düzenle",
      "description": "Bu bilgiler teslimat ve hesap güvenliği için kullanılır.",
      "save": "Kaydetmek",
      "saving": "Kaydediliyor..."
    },
    "validation": {
      "fullnameRequired": "Tam ad gerekli.",
      "phoneRequired": "Telefon gereklidir.",
      "phoneInvalid": "Geçerli bir telefon numarası girin.",
      "addressRequired": "Adres gerekli.",
      "transportRequired": "Taşıma türü gerekli."
    },
    "avatarUploadFailed": "Avatar yüklemesi başarısız oldu",
    "editAvatar": "Avatarınızı düzenleyin",
    "avatarAlt": "Kullanıcı avatarı",
    "greeting": "Merhaba {{name}}!",
    "userFallback": "Kullanıcı",
    "desktopSidebarTitle": "Profilde gezinme",
    "desktopSidebarDescription": "Hesap bölümleriniz arasında hızla geçiş yapın.",
    "desktopSidebarAria": "Profil bölümlerinde gezinme",
    "desktopSidebarCompletionLabel": "Tamamlama",
    "desktopSidebarCompletionValue": "%{{percent}}",
    "desktopQuickActionsTitle": "Hızlı eylemler",
    "desktopQuickSupport": "Desteği aç",
    "desktopQuickSecurity": "Güvenliğe git",
    "desktopWorkspaceTitle": "Profil çalışma alanı",
    "desktopWorkspaceSubtitle": "Kişisel ayarlarınızı anlaşılır bir masaüstü kontrol panelinden yönetin.",
    "desktopTileCompletion": "Profil",
    "desktopCompletionReady": "Profil tamamlandı ve hazır.",
    "desktopTileLanguage": "Aktif dil",
    "desktopLanguageHint": "Arayüz ve mesajlar için kullanılır.",
    "desktopTileNotifications": "Bildirimler",
    "desktopTileSync": "Senkronizasyon",
    "desktopStateEnabled": "Etkinleştirilmiş",
    "desktopStateDisabled": "Engelli",
    "desktopStateOnline": "Çevrimiçi",
    "desktopStateOffline": "Çevrimdışı",
    "desktopSyncHintOnline": "Değişiklikler hemen gönderilir.",
    "desktopSyncHintOffline": "Değişiklikler sıraya alınır ve daha sonra senkronize edilir.",
    "sections": {
      "info": "Bilgilerim",
      "claimCode": "Kod oluştur",
      "certification": "Satıcı sertifikası",
      "notifications": "Bildirimler",
      "language": "Dil",
      "support": "Yardım ve destek",
      "legals": "Yasal belgeler",
      "security": "Güvenlik"
    },
    "transport": {
      "bike": "Bisiklet",
      "scooter": "Scooter",
      "car": "Araba",
      "truck": "Kamyon",
      "walk": "yürüyerek"
    },
    "supportClaim": {
      "description": "Destek ile hızlı kimlik kontrolleri için bu kodu kullanın.",
      "codeLabel": "Destek kodu",
      "noCodeHint": "Henüz aktif kod yok. Başlamak için bir tane oluşturun.",
      "activeCodeHint": "Bir kod zaten etkin. Yeni bir tane görüntülemek için yeniden oluşturun.",
      "expiresAt": "Geçerlilik tarihi: {{date}}",
      "generate": "Kod oluştur",
      "regenerate": "Yenile",
      "generating": "Oluşturuluyor...",
      "copyCta": "Kodu kopyala",
      "feedback": {
        "generateSuccess": "Destek kodu başarıyla oluşturuldu.",
        "generateFailed": "Destek kodu oluşturulamıyor.",
        "copySuccess": "Kod kopyalandı.",
        "copyFailed": "Kod kopyalanamıyor."
      }
    },
    "certification": {
      "statusLabel": "Doğrulama durumu",
      "ambassadorClaimDescription": "Temsilci ağ bağlantısı için kullanılan satıcı kodunu oluşturun.",
      "ambassadorLabel": "Büyükelçi",
      "certifiedByLabel": "Sertifikalı",
      "certifiedAtLabel": "Sertifikalı",
      "restrictedReasonLabel": "Kısıtlama nedeni",
      "seeDetails": "Ayrıntıları görüntüle",
      "codeLabel": "Ağ entegrasyon kodu",
      "noCodeHint": "Henüz aktif kod yok. Başlamak için bir tane oluşturun.",
      "activeCodeHint": "Bir kod zaten etkin. Yeni bir tane görüntülemek için yeniden oluşturun.",
      "expiresAt": "Geçerlilik tarihi: {{date}}",
      "generate": "Kod oluştur",
      "regenerate": "Yenile",
      "generating": "Oluşturuluyor...",
      "copyCta": "Kodu kopyala",
      "feedback": {
        "generateSuccess": "Entegrasyon kodu başarıyla oluşturuldu.",
        "generateFailed": "Entegrasyon kodu oluşturulamıyor.",
        "copySuccess": "Kod kopyalandı.",
        "copyFailed": "Kod kopyalanamıyor."
      },
      "status": {
        "preparing": "Hazırlanıyor",
        "in_review": "İnceleniyor",
        "certified": "Sertifikalı",
        "restricted": "Sınırlı",
        "unknown": "Bilinmiyor"
      }
    },
    "roleSubtitle": {
      "client": "Müşteri alanınıza hoş geldiniz",
      "vendeur": "Yerel mahallenizi desteklediğiniz için teşekkür ederiz",
      "livreur": "Teslimat aynı zamanda yerel bağlantılar da yaratır",
      "ambassadeur": "Yerel Riveltime ağını kuruyorsunuz",
      "admin": "Platform operasyonlarını yönetiyorsunuz"
    }
  },
  "stripe": {
    "redirectError": "Şerit yönlendirmesi başarısız oldu.",
    "genericError": "Beklenmeyen bir hata oluştu.",
    "sessionExpired": "Oturumun süresi doldu. Lütfen tekrar oturum açın.",
    "emailNotVerifiedSync": "E-posta yeni doğrulandı mı? Lütfen birkaç saniye bekleyip yeniden deneyin.",
    "reconnectActionRequired": "Stripe hesabı bu ortamda kullanılamıyor. Yeniden bağlanmak için Stripe'ı Etkinleştir'e tıklayın.",
    "serverUnreachable": "Sunucuya ulaşılamıyor.",
    "reconnectRequired": "Stripe hesabı bu ortamda kullanılamıyor. Yeniden bağlantı gerekli.",
    "manageAccountAria": "Stripe hesabımı yönet",
    "manageAccount": "Stripe hesabımı yönet",
    "loadingAria": "Şerit yükleme",
    "connecting": "Bağlanıyor...",
    "activateAria": "Stripe'ı etkinleştir",
    "activate": "Stripe'ı etkinleştir",
    "dashboardLoadError": "Stripe verileri yüklenirken hata oluştu.",
    "connected": "Stripe hesabı bağlandı",
    "connectTitle": "Stripe'a bağlan",
    "connectDescription": "Bakiyeleri ve ödemeleri takip etmek için Stripe hesabınızı bağlayın.",
    "summaryTitle": "Finansal özet",
    "availableBalance": "Mevcut bakiye",
    "pendingAmount": "Bekleyen tutar",
    "payoutFrequency": "Ödeme sıklığı",
    "bankAccount": "Bağlı banka hesabı",
    "lastPayouts": "En son ödemeler",
    "statusLabel": "Durum",
    "statusPaid": "Paralı",
    "statusPending": "Askıda olması",
    "feesLabel": "Şerit ücretleri",
    "transferDestination": "Banka hesabınıza aktarıldı",
    "bankAccountMasked": "•••• •••• 1234",
    "na": "Yok",
    "frequency": {
      "daily": "günlük",
      "weekly": "haftalık",
      "monthly": "aylık",
      "unknown": "bilinmiyor"
    }
  },
  "paymentMethods": {
    "card": "Kart",
    "cash": "Peşin",
    "applePay": "Apple Pay",
    "googlePay": "Google Pay",
    "mealVoucher": "Yemek kuponu",
    "save": "Kaydetmek"
  },
  "home": {
    "notProvided": "Sağlanmadı",
    "storeFallback": "Mağaza",
    "visual": "görsel",
    "lastVisit": "Son ziyaret",
    "closed": "Kapalı",
    "open": "Açık",
    "distanceAria": "Mesafe {{value}} kilometre",
    "featuredBadge": "Öne Çıkanlar",
    "categoryFallback": "bu kategori",
    "discoverInCategory": "{{category}}'da keşfedin",
    "view": "Görüş",
    "featuredProductSubtitle": "Riveltime'da öne çıkan promosyon seçimi",
    "discover": "Keşfetmek",
    "offer": "Teklif",
    "sections": {
      "recents": "Son ziyaretleriniz",
      "discoverForYou": "Sizin için keşfedin",
      "bestSellers": "Yerel en çok satanlar",
      "allStores": "Tüm mağazalar"
    },
    "categories": {
      "food": "Yiyecek",
      "restaurant": "Restoran",
      "fashion": "Moda",
      "health": "Sağlık",
      "tech": "Teknoloji",
      "mobility": "Hareketlilik",
      "diy": "Kendin Yap",
      "garden": "Bahçe"
    },
    "filters": {
      "quickTitle": "Hızlı eylemler",
      "openNow": "Şimdi aç",
      "popular": "Popüler",
      "delivery": "Teslimat",
      "free": "özgür",
      "nearby": "Yakında",
      "categoriesTitle": "Kategoriler",
      "distanceOption": "≤ {{km}} km"
    },
    "search": {
      "defaultPlaceholder": "Bir mağaza veya ürün arayın...",
      "morningPlaceholder": "Bu sabah bir şeye mi ihtiyacınız var?",
      "dayPlaceholder": "Yakınınızda ihtiyacınız olanı bulun",
      "eveningPlaceholder": "Hareket etmeden kendinize davranın",
      "aria": "Bir mağaza veya ürün arayın"
    },
    "featuredMessages": {
      "1": "Keşfetmeniz gereken yerel bir mücevher",
      "2": "Tutkulu işçilik, özel seçilmiş seçim",
      "3": "Burası sıradan bir mağaza değil...",
      "4": "İçeri girin, keşfedin, keyfini çıkarın",
      "5": "Müşteriler onu seviyor, nedenini göreceksiniz",
      "6": "Bugün sizin için seçildik",
      "7": "Peki ya bir sonraki favoriniz buysa?"
    },
    "announcement": {
      "sunny": {
        "title": "Bugün güneşli bir gün",
        "subtitle": "En iyi yerel noktaların tadını çıkarın"
      },
      "rainy": {
        "title": "Bugün yağmurlu",
        "subtitle": "Teslim alın ve rahat kalın"
      },
      "cold": {
        "title": "Dışarısı soğuk",
        "subtitle": "Sıcak kalın, gerisini biz hallederiz"
      },
      "morning": {
        "title": "Günaydın",
        "subtitle": "Gününüze harika bir yerel seçimle başlayın"
      },
      "evening": {
        "title": "Sessiz bir akşam mı?",
        "subtitle": "Kanepenizden sipariş verin"
      }
    },
    "prelaunch": {
      "badge": "Yakında gelecek",
      "title": "Riveltime yakında geliyor",
      "description": "Bölgenizdeki yerel satıcı ve kurye ağını tamamlıyoruz.",
      "bannerText": "Riveltime yakında geliyor",
      "bannerAction": "Daha fazla bilgi edin",
      "orderDisabled": "Sipariş (yakında)",
      "modalHeader": "Riveltime yakında geliyor",
      "modalTitle": "Lansmandan sadece birkaç adım önce",
      "modalDescription": "Aşamalı açılış",
      "modalBody": "Bölgenizdeki yerel satıcı ve kurye ağını tamamlıyoruz.",
      "waitlistLabel": "Haberdar olun",
      "waitlistPlaceholder": "E-posta adresiniz",
      "waitlistHint": "Bölgenizde Riveltime açılır açılmaz bildirim alın.",
      "waitlistSubmit": "Haberdar olun",
      "waitlistSubmitting": "Gönderiliyor...",
      "waitlistInvalidEmail": "Geçerli bir e.",
      "waitlistSuccessFallback": "Teşekkürler, lansmanla ilgili bilgilendirileceksiniz.",
      "waitlistErrorFallback": "Şu anda abone olunamıyor.",
      "ctaPrimary": "Genel önizlemeye bakın",
      "ctaSecondary": "ben bir satıcıyım",
      "illustrationAlt": "Riveltime lansman öncesi illüstrasyonu"
    },
    "accountLink": {
      "close": "Kapalı",
      "modalHeader": "Riveltime yakında geliyor",
      "modalTitle": "Bu e-posta zaten bir hesaba bağlı",
      "modalBody": "Tek bir profil tutmak için oturum açma yöntemlerinizi güvenli bir şekilde bağlayın.",
      "emailLabel": "Algılanan e-posta",
      "linkCta": "Oturum açma yöntemlerimi bağla",
      "signInExistingCta": "Mevcut yöntemle oturum açın",
      "processing": "Doğrulanıyor...",
      "success": "Bağlantı tamamlandı. Lütfen tekrar oturum açın.",
      "errorFallback": "Bu oturum açma yöntemleri şu anda bağlanamıyor."
    },
    "welcomeTitle": "Riveltime'a hoş geldiniz",
    "welcomeSubtitle": "Saniyeler içinde sipariş verebileceğiniz yerel pazar yeri.",
    "order": "Emir",
    "continueWithoutAccount": "Hesap olmadan devam et",
    "proQuestion": "Tüccar mısınız yoksa kurye mi?",
    "accessVendor": "Satıcı erişimi",
    "accessCourier": "Kurye erişimi",
    "hello": "Merhaba {{name}}",
    "yourRole": "Rolünüz:",
    "preparingSpace": "Alanınız hazırlanıyor...",
    "goToMySpace": "Alanıma eriş",
    "logout": "Oturumu kapat",
    "installPrompt": "Daha hızlı erişim için Riveltime'ı yükleyin",
    "install": "Düzenlemek",
    "androidInstallTitle": "Android'e yükleme",
    "androidInstallHintGeneric": "Tarayıcı menüsünü açın ve ardından Uygulamayı yükle veya Ana ekrana ekle öğesine dokunun.",
    "androidInstallHintSamsung": "Samsung Internet'te menüyü açın, ardından Uygulamayı yükle veya Ana ekrana sayfa ekle seçeneğini seçin.",
    "androidInstallHintXiaomi": "Mi Tarayıcıda menüyü açın, ardından Ana ekrana ekle veya Uygulamayı yükle seçeneğini seçin.",
    "iosInstallTitle": "iPhone'a yükleme",
    "iosInstallStep1": "Basmak",
    "iosInstallShare": "Paylaşmak",
    "iosInstallStep2": "Daha sonra",
    "iosInstallHomeScreen": "Ana ekranda",
    "close": "Kapalı",
    "logoAlt": "Riveltime Logosu",
    "roles": {
      "client": "Müşteri",
      "vendeur": "Satıcı",
      "livreur": "Teslimatçı"
    }
  },
  "clientHome": {
    "prelaunch": {
      "badge": "Yakında gelecek",
      "title": "Riveltime yakında bölgenizde geliyor",
      "description": "Şimdilik aktif mağazamız yok. Kademeli olarak açılıyoruz, lütfen kısa süre sonra tekrar kontrol edin.",
      "ctaPrimary": "Eve dön",
      "ctaSecondary": "Ağa katıl",
      "illustrationAlt": "Ağ açılışı bekleyen illüstrasyon"
    }
  },
  "boutiqueStore": {
    "sessionDesyncedReconnectRequired": "Oturum senkronize değil. Yeniden bağlantı gerekli.",
    "accountSyncInProgressRetry": "Hesap senkronize ediliyor. Birkaç saniye sonra tekrar deneyin veya tekrar giriş yapın.",
    "unableToLoadYourStores": "Mağazalarınız yüklenemiyor.",
    "storeDeleted": "Mağaza silindi.",
    "unableToDeleteStore": "Mağaza silinemiyor."
  },
  "deliveryAdmin": {
    "adminView": "Yönetici görünümü",
    "activeOrders": "Aktif siparişler",
    "sidebarTitle": "Siparişlerim",
    "scopeTitle": "Takip",
    "total": "Toplam",
    "order": "Emir",
    "details": "Detaylar",
    "unknown": "Bilinmiyor",
    "dash": "-",
    "paymentLabel": "Ödeme :",
    "tabs": {
      "inProgress": "Devam etmekte",
      "history": "Tarihsel"
    },
    "captureStatus": {
      "authorized": "İzin verilmiş",
      "succeeded": "Başarılı",
      "captured": "Esir almak",
      "canceled": "İptal edildi",
      "failed": "Arızalı"
    },
    "emptyOrdersForStatus": "{{status}} komutu yok.",
    "storeFallback": "Mağaza belirtilmedi",
    "clientFallback": "Müşteri bilgilendirilmedi",
    "operationalStatus": "Operasyonel durum",
    "newStatus": "Yeni durum",
    "assignDelivererBeforeStatusChange": "Bu durumu değiştirmeden önce bir teslimat görevlisi atayın.",
    "apply": "Uygula",
    "deliverer": "Teslimatçı",
    "assignOrReassign": "Ata veya yeniden ata",
    "loadingDeliverers": "Teslimatçılar yükleniyor",
    "updateDeliverer": "Teslimat görevlisini güncelleyin",
    "systemActions": "Sistem eylemleri",
    "resetToPending": "Ütü beklemede",
    "cancelOrder": "Siparişi iptal et",
    "forceCaptureTitle": "Ödeme yakalamayı zorla",
    "forceCaptureDescription": "Ödemeyi kaydeder ve siparişi teslim edildi olarak işaretler.",
    "reasonPlaceholder": "Sebep (isteğe bağlı)",
    "captureAndDeliver": "Yakalayın ve teslim edin",
    "manageOrder": "Siparişi yönet",
    "actionImpossible": "Bu komut için eylem imkansız.",
    "loadError": "Yönetici komutları yüklenemedi.",
    "orderPausedWithReason": "Komut duraklatıldı{{reason}}",
    "toasts": {
      "statusUpdated": "Durum güncellendi.",
      "orderResetPending": "Sipariş tekrar beklemeye alındı.",
      "delivererUpdated": "Teslimatçı güncellendi.",
      "orderCancelled": "Sipariş iptal edildi.",
      "paymentCapturedDelivered": "Ödeme alındı ​​ve sipariş teslim edildi."
    }
  },
  "courses": {
    "tabs": {
      "aroundMe": "Etrafımda",
      "route": "Seyahat Programı"
    },
    "adsLabel": "Duyurular mevcut",
    "placeholders": {
      "addressAround": "Çevremdeki adres",
      "departureAddress": "Kalkış adresi",
      "arrivalAddress": "Varış adresi",
      "radiusKm": "Yarıçap"
    },
    "banners": {
      "connectionRequired": "Siparişi kabul etmek için oturum açmanız gerekiyor.",
      "orderAccepted": "Sipariş kabul edildi.",
      "orderUnavailable": "Bu komut artık mevcut değil.",
      "acceptNetworkError": "Kabul sırasında ağ hatası."
    },
    "emptyPendingOrders": "Bekleyen emir yok.",
    "modal": {
      "orderDetails": "Sipariş ayrıntıları",
      "noImage": "Resim yok",
      "itemsCount": "{{count}} öğe(ler)",
      "store": "Mağaza",
      "delivery": "Teslimat",
      "storePhotoAlt": "Fotoğraf: {{store}}"
    },
    "aria": {
      "radiusInKm": "Kilometre cinsinden yarıçap",
      "deliveryPrice": "Teslimat fiyatı",
      "estimatedDelay": "Tahmini son tarih",
      "distance": "Mesafe",
      "recommendedVehicle": "Önerilen araç",
      "totalWeight": "Toplam ağırlık",
      "totalVolume": "Toplam hacim",
      "billedWeight": "Fatura ağırlığı",
      "store": "Mağaza",
      "storeAddress": "Mağaza adresi",
      "storePhone": "Telefon mağazası",
      "client": "Müşteri",
      "deliveryAddress": "Teslimat adresi",
      "clientPhone": "Müşteri telefonu"
    },
    "notProvidedFemale": "Belirtilmedi",
    "notProvidedMale": "Belirtilmedi",
    "skip": "Geçmek",
    "accept": "Kabul etmek",
    "loading": "Yükleniyor",
    "km": "kilometre",
    "kg": "kilogram",
    "m3": "m3"
  },
  "gestionModal": {
    "create": "Yaratmak",
    "edit": "Değiştirmek için",
    "store": "mağaza",
    "product": "ürün",
    "deleteItem": "SİLMEK",
    "storeName": "Mağaza Adı",
    "storeNamePlaceholder": "Mağaza Adı",
    "category": "Kategori",
    "selectCategory": "Bir kategori seçin",
    "categories": {
      "alimentation": "Yiyecek",
      "restaurant": "Restoran",
      "sante": "Sağlık",
      "mobilite": "Hareketlilik",
      "pretAPorter": "Hazır giyim",
      "informatique": "Bilgisayar Bilimi",
      "bricolage": "Kendin Yap",
      "jardin": "Bahçe"
    },
    "fullAddress": "Tam adres",
    "address": "Adres",
    "defineOpeningHours": "Açılış saatlerini tanımlayın",
    "exceptionalClosure": "Olağanüstü kapatma",
    "deliveryFeeParticipationTitle": "Teslimat maliyetlerine katkı",
    "enableParticipation": "Olanak vermek",
    "enableParticipationAria": "Teslimat maliyetlerine katkıyı etkinleştir",
    "participationShareLabel": "Kapsanan teslimat ücreti payı",
    "participationHelp": "Mağazanızın karşıladığı teslimat ücretinin yüzdesi.",
    "participationOptions": {
      "25": "Teslimat ücretinin %25'i",
      "50": "Teslimat ücretinin %50'si",
      "75": "Teslimat ücretinin %75'i",
      "100": "Teslimat ücretinin %100'ü"
    },
    "contributionCapLabel": "Maksimum sınır (sepetin yüzdesi)",
    "contributionOptions": {
      "10": "sepetin maksimum %10'u",
      "20": "sepetin maksimum %20'si",
      "30": "sepetin maksimum %30'u"
    },
    "contributionHelp": "Marjınızı korumak için maksimum sınır.",
    "participationPreview": "Örnek: ücret {{deliveryFee}} EUR, sepet {{cartAmount}} EUR -> {{amount}} EUR tutarında ödeme alırsınız.",
    "coverImage": "Kapak resmi",
    "image": "Resim",
    "imageConstraints": "Kabul edilen formatlar: JPG, PNG. Önerilen boyut 2 MB'tan az.",
    "collection": "Koleksiyon",
    "productName": "Ürün Adı",
    "name": "İsim",
    "price": "Fiyat",
    "description": "Tanım",
    "selectShippingFormat": "Bir aktarım formatı seçin",
    "shippingGroups": {
      "smallPackages": "Küçük paketler",
      "mediumPackages": "Orta paketler",
      "largeObjects": "Büyük nesneler"
    },
    "shippingOptions": {
      "petit_colis": "Küçük paket",
      "sac_ou_vetement": "Çanta veya kıyafet",
      "carton_moyen": "Orta karton",
      "fragile": "Kırılgan",
      "meuble": "Mobilya",
      "gros_objet": "Büyük nesne"
    },
    "preparingProductOptions": "Ürün seçenekleri hazırlanıyor...",
    "save": "Kaydetmek",
    "saving": "Kayıt..."
  },
  "variableEditor": {
    "productOptionsAria": "Ürün seçeneklerini düzenleme",
    "productOptionsTitle": "Ürün seçenekleri",
    "addOption": "Bir seçenek ekle",
    "emptyHelpPrefix": "Gibi seçenekler oluşturabilirsiniz",
    "emptyHelpSuffix": "Ürünü kişiselleştirmek için.",
    "examples": {
      "size": "Boyut",
      "dough": "Hamur",
      "supplements": "Takviyeler"
    },
    "optionLegend": "Seçenek {{index}}",
    "optionName": "Seçenek adı",
    "optionNamePlaceholder": "Örn: Boyut",
    "type": "Tür",
    "singleChoice": "Tek seçim",
    "multipleChoice": "Çoktan seçmeli",
    "required": "Zorunlu",
    "hideDetails": "Ayrıntıları gizle",
    "showDetails": "Ayrıntıları göster",
    "deleteOptionAria": "{{index}} seçeneğini kaldır",
    "examplePrefix": "Örnek :",
    "exampleSingleRequired": "tek seçim gerekli",
    "or": "Veya",
    "exampleMultipleMax": "Maksimum ile çoktan seçmeli",
    "groupHelpSrOnly": "Bu grup için gelişmiş seçenekleri yapılandırır.",
    "advancedOptionsAria": "Gelişmiş seçenekler",
    "advancedOptions": "Gelişmiş seçenekler",
    "hideAdvancedOptions": "Gelişmiş seçenekleri gizle",
    "max": "Maksimum",
    "maxSelectionsAria": "Maksimum seçim sayısı",
    "technicalKey": "Teknik anahtar",
    "technicalKeyPlaceholder": "Örn: boyut",
    "groupKeyAria": "Grubun teknik anahtarı",
    "choiceLabel": "Seçilecek kelime",
    "choiceLabelPlaceholder": "Örn: Büyük",
    "extraCost": "Ek",
    "extraCostHelpSrOnly": "Taban fiyata eklenen tutar.",
    "defaultChoiceSingle": "Varsayılan seçim",
    "deleteChoiceAria": "{{value}} seçeneğini sil",
    "addChoiceAria": "Bir seçim ekleyin",
    "addChoice": "Bir seçim ekleyin",
    "footerHelp": "Seçenekler yalnızca bu ürün için geçerli olacaktır.",
    "defaultOptionLabel": "Seçenek"
  },
  "panier": {
    "title": "Sepet",
    "modalDescription_one": "Sepetinizde {{count}} ürün var",
    "modalDescription_other": "Sepetinizde {{count}} ürün var",
    "emptyCartDescription": "Sepetiniz boş.",
    "emptyCart": "Şu anda makale yok.",
    "discoverStores": "Mağazaları keşfedin",
    "atStore": "evinde",
    "quantityForProductAria": "{{name}} için miktar",
    "removeOneAria": "{{name}} adresinden bir makaleyi kaldırın",
    "addOneAria": "{{name}} adresinden bir makale ekleyin",
    "products": "Ürünler",
    "delivery": "Teslimat",
    "participationOf": "{{store}} katılımı",
    "deliveryEstimateLoading": "Teslimat maliyetlerinin hesaplanması...",
    "chooseAddressForEstimate": "Teslimatı tahmin etmek için bir adres seçin.",
    "loginToEstimate": "Tahmin almak için giriş yapın.",
    "login": "Giriş yapmak",
    "estimatedTotal": "Toplam tahminler",
    "doubleDash": "--",
    "selectAddressPrompt": "Bir adres seçin",
    "defaultRotatingMessage": "Sizin için en uygun fiyatı hesaplıyoruz.",
    "preparing": "Hazırlık...",
    "order": "Emir",
    "chooseAddress": "Bir adres seçin",
    "estimateError": "Teslimatı tahmin etmek imkansız.",
    "authRequiredToPay": "Ödeme yapmak için oturum açmanız gerekiyor.",
    "serverError": "Sunucu hatası.",
    "storeFallback": "Mağaza",
    "noPaymentPrepared": "Herhangi bir ödeme hazırlanmadı.",
    "paymentInfoUnavailable": "Ödeme bilgileri mevcut değil.",
    "preparePaymentError": "Ödeme hazırlığı sırasında hata oluştu.",
    "messages": {
      "1": "Siparişinizi hazırlıyoruz...",
      "2": "En iyi rota hesaplanıyor.",
      "3": "Ürünleriniz çok yakında geliyor.",
      "4": "Teslimat maliyetlerini optimize ediyoruz.",
      "5": "Bir dakika daha...",
      "6": "Sepetiniz emin ellerde.",
      "7": "Makalelerin kullanılabilirliğini kontrol ediyoruz.",
      "8": "Mağazalar hazırlanıyor.",
      "9": "Sabrınız için teşekkür ederiz.",
      "10": "Tahmininizi sonuçlandırıyoruz.",
      "11": "Neredeyse bitti.",
      "12": "Ödemeniz birazdan hazır olacak.",
      "13": "Ödeme bilgilerini senkronize ediyoruz.",
      "14": "Son kontroller yapılıyor."
    }
  }
};
